<template>
    <div class="footer">
		<ul class="footer-list">
			<li class="">
				<span>友情链接：</span>
				<a href="https://www.cacms.ac.cn/">中国中医科学院</a>
				<a href="http://www.cintcm.ac.cn/">中国中医科学院中医药信息研究所</a>
			</li>
			<li class="list-flex">
				<a href="/tcmkb/pages/helpCenter.jsp">帮助中心</a>
				<a href="/tcmkb/pages/aboutUs.jsp">关于我们</a>
				<a href="/tcmkb/pages/aboutUs.jsp#2">联系我们</a>
				<a style="margin-right: 0" href="/tcmkb/pages/legalNotices.jsp">法律声明</a>
			</li>
			<li class="list-border"> ©2014中国工程科技知识中心ICP备案号：京ICP备05055726号-9 </li>
			<li class="list-txt-small"> 中国中医科学院中医药信息研究所版权所有 </li>
		</ul>
	</div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.footer{
	width: 100%;
    height: 120px;
    background: #262628;
    font-size: 14px;
    line-height: 30px;
    padding: 10px 0;
    box-sizing: content-box;
	.footer-list{
		width: 420px;
		margin: 0 auto;
		li{
			color: #fff;
    		text-align: center;
			font-weight: bold;
			a{
				color:#fff;
			}
		}
		.list-flex{
			display: flex;
			justify-content: space-evenly
		}
		.list-border{
			border-bottom: 1px solid #fff;
		}
		.list-txt-small{
			font-size: 12px;
		}
	}
}
</style>